export default __webpack_public_path__ + "static/media/wagmi_blurb.998e234d.png";